import { ATTACHMENT_ACCEPT } from "../../api/attachments";
import {
  EMPTY_APPLY_FORM,
  MARITAL_STATUS_OPTIONS,
  MILITARY_STATUS_OPTIONS,
} from "../../utils/recruitmentApplyOptions";

export { EMPTY_APPLY_FORM };

export default function JobApplyForm({
  form,
  setForm,
  cvFile,
  setCvFile,
  onSubmit,
  submitting = false,
  error = "",
  submitLabel = "تقديم الطلب",
}) {
  return (
    <form className="careers-form" onSubmit={onSubmit}>
      {error ? <div className="careers-error">{error}</div> : null}
      <label>
        الاسم بالكامل *
        <input
          required
          maxLength={150}
          value={form.fullName}
          onChange={(e) => setForm({ ...form, fullName: e.target.value })}
        />
      </label>
      <label>
        البريد الإلكتروني *
        <input
          required
          type="email"
          maxLength={150}
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
      </label>
      <label>
        رقم الهاتف *
        <input
          required
          minLength={8}
          maxLength={20}
          value={form.phone}
          onChange={(e) => setForm({ ...form, phone: e.target.value })}
        />
      </label>
      <label>
        الرقم القومي *
        <input
          required
          maxLength={30}
          value={form.nationalId}
          onChange={(e) => setForm({ ...form, nationalId: e.target.value })}
        />
      </label>
      <label>
        تاريخ الميلاد *
        <input
          required
          type="date"
          value={form.dateOfBirth}
          onChange={(e) => setForm({ ...form, dateOfBirth: e.target.value })}
        />
      </label>
      <label>
        محل الإقامة *
        <input
          required
          maxLength={300}
          value={form.residence}
          onChange={(e) => setForm({ ...form, residence: e.target.value })}
          placeholder="المحافظة — المنطقة"
        />
      </label>
      <label>
        المؤهل الدراسي *
        <input
          required
          maxLength={300}
          value={form.education}
          onChange={(e) => setForm({ ...form, education: e.target.value })}
          placeholder="مثال: بكالوريوس تجارة"
        />
      </label>
      <label>
        الموقف من التجنيد *
        <select
          required
          value={form.militaryStatus}
          onChange={(e) => setForm({ ...form, militaryStatus: e.target.value })}
        >
          <option value="">اختر...</option>
          {MILITARY_STATUS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>
      <label>
        الحالة الاجتماعية *
        <select
          required
          value={form.maritalStatus}
          onChange={(e) => setForm({ ...form, maritalStatus: e.target.value })}
        >
          <option value="">اختر...</option>
          {MARITAL_STATUS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>
      <label>
        الخبرات السابقة *
        <textarea
          required
          maxLength={4000}
          rows={4}
          value={form.previousExperience}
          onChange={(e) => setForm({ ...form, previousExperience: e.target.value })}
          placeholder="اذكر أهم الخبرات والمهام"
        />
      </label>
      <label>
        ملاحظات (اختياري)
        <textarea
          maxLength={2000}
          rows={3}
          value={form.notes}
          onChange={(e) => setForm({ ...form, notes: e.target.value })}
        />
      </label>
      <label>
        السيرة الذاتية * (PDF أو Word أو صورة)
        <input
          required
          type="file"
          accept={ATTACHMENT_ACCEPT}
          onChange={(e) => setCvFile(e.target.files?.[0] || null)}
        />
      </label>
      <button className="careers-submit" type="submit" disabled={submitting}>
        {submitting ? "جارٍ الإرسال..." : submitLabel}
      </button>
    </form>
  );
}
